import { Field, ID, ObjectType } from 'type-graphql'
import {
  Column,
  CreateDateColumn,
  Entity,
  Index,
  ManyToOne,
  PrimaryGeneratedColumn,
  RelationId,
  UpdateDateColumn
} from 'typeorm'

import { User } from '@things-factory/auth-base'
import { Domain } from '@things-factory/shell'

import { DataKeyItem } from './data-key-item-type.js'
import { DataSetReportType } from '../data-set/data-set.js'

@Entity()
@Index('ix_data_key_set_0', (dataKeySet: DataKeySet) => [dataKeySet.domain, dataKeySet.name], { unique: true })
@ObjectType({
  description:
    'Represents a data key set that defines the categorization and indexing structure for data samples. This entity organizes data using key items for efficient search and partitioning.'
})
export class DataKeySet {
  @PrimaryGeneratedColumn('uuid')
  @Field(type => ID, { description: 'Unique identifier for the data key set.' })
  readonly id: string

  @ManyToOne(type => Domain)
  @Field(type => Domain)
  domain?: Domain

  @RelationId((dataKeySet: DataKeySet) => dataKeySet.domain)
  domainId?: string

  @Column()
  @Field()
  name: string

  @Column({
    nullable: true
  })
  @Field({ nullable: true })
  description?: string

  @Column({
    nullable: true
  })
  @Field({ nullable: true })
  active?: boolean

  @Column({ nullable: true })
  @Field({ nullable: true })
  reportType?: DataSetReportType

  @Column({ nullable: true })
  @Field({ nullable: true })
  reportView?: string

  @Column('simple-json', { nullable: true })
  @Field(type => [DataKeyItem], {
    nullable: true,
    description: 'The key items that define the categorization structure for this key set.'
  })
  dataKeyItems: DataKeyItem[]

  @CreateDateColumn()
  @Field({ nullable: true })
  createdAt?: Date

  @UpdateDateColumn()
  @Field({ nullable: true })
  updatedAt?: Date

  @ManyToOne(type => User, { nullable: true })
  @Field(type => User, { nullable: true })
  creator?: User

  @RelationId((dataKeySet: DataKeySet) => dataKeySet.creator)
  creatorId?: string

  @ManyToOne(type => User, { nullable: true })
  @Field(type => User, { nullable: true })
  updater?: User

  @RelationId((dataKeySet: DataKeySet) => dataKeySet.updater)
  updaterId?: string

  @Field(type => String, { nullable: true })
  thumbnail?: string
}
